var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import BetterScroll from 'better-scroll';
import MouseWheel from '@better-scroll/mouse-wheel';
import Wheel from '@better-scroll/wheel';
export function createNumberScrollProvider(dotNetNumberScrollProvider) {
    return new NumberScrollProvider(dotNetNumberScrollProvider);
}
class NumberScrollProvider {
    constructor(dotNetNumberScrollProvider) {
        this.dotNetNumberScrollProvider = dotNetNumberScrollProvider;
    }
    initialize(scrollElementId, selectedIndex) {
        BetterScroll.use(MouseWheel);
        BetterScroll.use(Wheel);
        this.createScrollInstance(scrollElementId, selectedIndex);
    }
    refresh() {
        this.scrollInstance.refresh();
    }
    createScrollInstance(scrollElementId, selectedIndex) {
        const scrollElement = document.getElementById(scrollElementId);
        this.scrollInstance = new BetterScroll(scrollElement, {
            movable: true,
            mouseWheel: true,
            useTransition: true,
            wheel: {
                selectedIndex: selectedIndex,
                wheelWrapperClass: 'wheel-scroll',
                wheelItemClass: 'wheel-item',
                wheelDisabledItemClass: 'wheel-disabled-item',
                rotate: 25,
                adjustTime: 100,
                itemHeight: 35
            },
            probeType: 3,
            click: true
        });
        this.scrollInstance.on('scrollEnd', () => __awaiter(this, void 0, void 0, function* () {
            const selectedIndex = this.scrollInstance.getSelectedIndex();
            yield this.dotNetNumberScrollProvider.invokeMethodAsync('OnSelectedValueChanged', selectedIndex);
        }));
    }
}
